import React, { useEffect, forwardRef, useState } from 'react';

import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import FormControl from '@mui/material/FormControl';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import {
  DataGrid,
  GridToolbarContainer,
  GridActionsCellItem,
} from '@mui/x-data-grid';

import moment from "moment";
import "moment/locale/es";

import Loader from "components/Loader/Loader";

import { Redirect } from 'react-router-dom';

moment.locale("es");

const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function Alta(){
    const [Estatus, setEstatus] = useState([]);
    const [GruposVulnerables, setGruposVulnerables] = useState([]);

    const [color, setColor] = useState("");
    const [message, setMessage] = useState("");
    const [openSnackbar, setOpenSnackbar] = useState(false);

    const [load, setLoad] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [openDialogComment, setOpenDialogComment] = useState(false);

    const [NombreCliente, setNombreCliente] = useState("");
    const [Producto, setProducto] = useState("");
    const [UltimosDigitos, setUltimosDigitos] = useState("");
    const [FechaCobro, setFechaCobro] = useState(null);
    const [AltaRenovacion, setAltaRenovacion] = useState("");

    const [Correo, setCorreo] = useState("");
    const [RFC, setRFC] = useState("");
    const [Edad, setEdad] = useState("");
    const [Telefono, setTelefono] = useState("");
    const [CanalVenta, setCanalVenta] = useState("");
    const [FinPrograma, setFinPrograma] = useState(null);
    const [FechaInformacion, setFechaInformacion] = useState(null);
    const [MesesRestantes, setMesesRestantes] = useState("");
    const [MontoCobrado, setMontoCobrado] = useState(0);
    const [LineaCredito, setLineaCredito] = useState(0);
    const [FechaCorte, setFechaCorte] = useState(null);

    const [ProgramaLealtad, setProgramaLealtad] = useState("");
    const [NombreAdicional, setNombreAdicional] = useState("");
    const [ProgramaCero, setProgramaCero] = useState("");
    const [Acelerador, setAcelerador] = useState("");
    const [PerfilCliente, setPerfilCliente] = useState("");

    const [IdEstatus, setIdEstatus] = useState("1");
    const [IdGruposVulnerables, setIdGruposVulnerables] = useState("1");

    const [FolioCancelacion, setFolioCancelacion] = useState("");

    const [NombreAdicionalError, setNombreAdicionalError] = useState(false);
    const [RFCError, setRFCError] = useState(false);
    const [ProductoError, setProductoError] = useState(false);
    const [UltimosDigitosError, setUltimosDigitosError] = useState(false);

    const [Comentarios, setComentarios] = useState([]);
    const [TextoModal, setTextoModal] = useState("");
    const [Comentario, setComentario] = useState("");
    const [IdCapturaComentarios, setIdCapturaComentarios] = useState(0);

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    const columnsComments = [
        { field: 'Comentario', headerName: 'Comentario', width: 220, editable: false },
        { field: 'FechaComentario', headerName: 'Fecha Comentario', width: 180, editable: true },    
        {
            field: 'actions',
            type: 'actions',
            headerName: 'Actions',
            width: 150,
            cellClassName: 'actions',
            getActions: ({row}) => {
            return [
                <GridActionsCellItem
                icon={<EditIcon />}
                label="Edit"
                className="textPrimary"
                onClick={EditarComentario(row)}
                color="inherit"
                key="edit"
                />,
                <GridActionsCellItem
                icon={<DeleteIcon />}
                label="Eliminar"
                onClick={EliminarComentario(row)}
                color="inherit"
                key="eliminar"
                />
            ];
            },
        },
    ];
    
    const AgregarComentario = () => {
        limpia();
        setOpenDialogComment(true);
        setTextoModal("Agregar Comentario");
    };

    function EditToolbar(props) {  
        return (
        <GridToolbarContainer>
            <Button color="primary" startIcon={<AddIcon />} onClick={AgregarComentario}>
                Agregar Comentario
            </Button>
        </GridToolbarContainer>
        );
    }

    const EditarComentario = (row) => () => {
        limpia();
        llenar(row);
        setOpenDialogComment(true);
        setTextoModal("Editar Comentario");
    };

    const EliminarComentario = (row) => () => {
        limpia();
        llenar(row);
        setOpenDialogComment(true);
        setTextoModal("Eliminar Comentario");
    };

    const limpia = () => {
        setComentario("");
        setIdCapturaComentarios(0);
    };

    const llenar = (row) => {
        setComentario(row.Comentario);
        setIdCapturaComentarios(row.IdCapturaComentarios);
    };

    const AceptarModalComentario = () => {
        const comentarioBase = {
            id: Math.random() * 10,
            IdCapturaComentarios:
                TextoModal === "Agregar Comentario"
                    ? (Comentarios.length > 0
                        ? Math.max(...Comentarios.map(c => c.IdCapturaComentarios)) + 1
                        : 1)
                    : IdCapturaComentarios,
            FechaComentario: moment(Date.now()).format("DD-MM-YYYY HH:mm:ss"),
            Comentario,
        };

        if (TextoModal === "Agregar Comentario") {
            setComentarios([...Comentarios, comentarioBase]);
            sendSnackBar("Comentario agregado correctamente", "success");
        } else if (TextoModal === "Editar Comentario") {
            const updatedComments = Comentarios.map((comment) =>
                comment.IdCapturaComentarios === comentarioBase.IdCapturaComentarios
                    ? { ...comment, ...comentarioBase }
                    : comment
            );
            setComentarios(updatedComments);
            sendSnackBar("Comentario actualizado correctamente", "success");
        } else {
            const updatedComments = Comentarios.filter(
                (comment) => comment.IdCapturaComentarios !== comentarioBase.IdCapturaComentarios
            );
            setComentarios(updatedComments);
            sendSnackBar("Comentario eliminado correctamente", "success");
        }

        setOpenDialogComment(false);
    };

    const getUser = () => {
        return JSON.parse(localStorage.getItem("userRetencion")).IdUsuario;
    };

    const sendSnackBar = (pmessage, pcolor) => {
        setOpenSnackbar(true);
        setColor(pcolor);
        setMessage(pmessage);
    };

    const SnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
    
        setOpenSnackbar(false);
    };

    const DialogClose = () => {
        setOpenDialog(false);
        setTimeout(function(){ window.location.reload(false); }, 1000);
    };

    const Login = async () => {
        let dataResponse;
        try {
            let header = {
                method: "POST",
                body: JSON.stringify({UserName: process.env.REACT_APP_USER, Password: process.env.REACT_APP_PASS}),
                headers: {
                    "Content-Type": "application/json"
                }
            };

            let response = await fetch(
                process.env.REACT_APP_URL_APICORE + "Login",
                header
            );

            dataResponse = await response.json();
        } catch (error) {
            sendSnackBar("Error de conexión", "error");
        }

        return dataResponse;
    };

    const InsertaCaptura = async (data, token) => {
        let dataResponse;
        try {
            let header = {
                method: "POST",
                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + token
                }
            };
    
            let response = await fetch(
                process.env.REACT_APP_URL_APICORE + "Captura/InsertaCaptura",
                header
            );

            dataResponse = await response.json();
        } catch (error) {
            sendSnackBar("Error de conexión", "error");
        }
    
        return dataResponse;
    };

    const ObtieneGruposVulnerables = async (token) => {
        let dataResponse;
        try {
            let header = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + token
                }
            };
    
            let response = await fetch(
                process.env.REACT_APP_URL_APICORE + "Estatus/ObtieneGruposVulnerables",
                header
            );

            dataResponse = await response.json();
        } catch (error) {
            sendSnackBar("Error de conexión", "error");
        }
    
        return dataResponse;
    };

    const ObtieneEstatusGrupo = async (token, data) => {
        let dataResponse;
        try {
            let header = {
                method: "POST",
                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + token
                }
            };
    
            let response = await fetch(
                process.env.REACT_APP_URL_APICORE + "Estatus/ObtieneEstatusGrupo",
                header
            );

            dataResponse = await response.json();
        } catch (error) {
            sendSnackBar("Error de conexión", "error");
        }
    
        return dataResponse;
    };

    const InsertaCapturaComentarios = async (data, token) => {
        let dataResponse;
        try {
            let header = {
                method: "POST",
                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + token
                }
            };
    
            let response = await fetch(
                process.env.REACT_APP_URL_APICORE + "Captura/InsertaCapturaComentarios",
                header
            );

            dataResponse = await response.json();
        } catch (error) {
            sendSnackBar("Error de conexión", "error");
        }
    
        return dataResponse;
    };

    const ValidaDatos = () => {
        let fecha = moment(Date.now());
        let folio_cancelacion = '';
        let error = false;

        if(UltimosDigitos.length < 4 && 
            (IdEstatus === 3 || IdEstatus === 4 || IdEstatus === 6 || IdEstatus === 16 || 
             IdEstatus === 36 || IdEstatus === 37
            )){
            setUltimosDigitosError(true);
            error = true;
        }

        if(NombreAdicional === ""){
            setNombreAdicionalError(true);
            error = true;
        }

        let regex = /^[A-Z&Ñ]{3,4}[0-9]{2}(0[1-9]|1[0-2])(0[1-9]|[12][0-9]|3[01])([A-Z0-9]{3})?$/;
        if(RFC === "" || regex.test(RFC.trim().toUpperCase()) === false){
            setRFCError(true);
            error = true;
        }

        if(Producto === ""){
            setProductoError(true);
            error = true;
        }

        if(IdEstatus === 3 || IdEstatus === 4 || IdEstatus === 6 || IdEstatus === 16){
            folio_cancelacion = 'C' + fecha.format('YYMMDD') + UltimosDigitos.slice(-4);
            setFolioCancelacion(folio_cancelacion);
        }

        if(IdEstatus === 36 || IdEstatus === 52){
            folio_cancelacion = 'CC' + fecha.format('YYMMDD') + UltimosDigitos.slice(-4);
            setFolioCancelacion(folio_cancelacion);
        }

        if(IdEstatus === 37){
            folio_cancelacion = 'CB' + fecha.format('YYMMDD') + UltimosDigitos.slice(-4);
            setFolioCancelacion(folio_cancelacion);
        }

        let datos = { NombreCliente, Producto, UltimosDigitos, FechaCobro, AltaRenovacion, Correo, RFC, 
            Telefono, CanalVenta, FinPrograma, FechaInformacion, MesesRestantes, FechaCorte,
            MontoCobrado: parseInt(MontoCobrado), LineaCredito: parseInt(LineaCredito), IdGrupo: 0,
            IdEstatus: parseInt(IdEstatus), IdSubEstatus: 0, IdEstatusCargo: 0, 
            IdGruposVulnerables: parseInt(IdGruposVulnerables), FechaCapturista: moment(Date.now()).toDate(), 
            Capturista: getUser(), FolioCancelacion: folio_cancelacion, ProgramaLealtad, NombreAdicional, 
            ProgramaCero, Acelerador, PerfilCliente };
        
        if(error === true){
            return { error: true }
        } else {
            return datos;
        }
    }

    const EnviaDatos = () => {
        try{
            setLoad(true);
            
            let datos = ValidaDatos();
            
            if(datos.error === undefined && Comentarios.length > 0){
                Login()
                .then(result => {
                    let token = result.token;
                    InsertaCaptura(datos, token)
                    .then(result => {
                        if(result.IdCaptura > 0){
                            Comentarios.forEach(comentario => {
                                let coms = {
                                    IdCaptura: parseInt(result.IdCaptura),
                                    Comentario: comentario.Comentario,
                                };
                                InsertaCapturaComentarios(coms, token)
                                .then(result => {});
                            });
                            
                            sendSnackBar("Registro exitoso", "success");
                            setOpenSnackbar(true);
                            setOpenDialog(true);
                        } else {
                            sendSnackBar("Error de conexión", "error");
                        }
        
                        setLoad(false);
                    });
                });
            } else {
                sendSnackBar("Los datos marcados con * son obligatorios", "error");
                setLoad(false);
            }
        } catch(error){
            sendSnackBar("Error de conexión", "error");
            setLoad(false);
        }
    };

    const UsuarioActivo = async (data, token) => {
        let dataResponse;
        try {
            let header = {
                method: "POST",
                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + token
                }
            };

            let response = await fetch(
                process.env.REACT_APP_URL_APICORE + "Usuario/UsuarioActivo",
                header
            );

            dataResponse = await response.json();
        } catch (error) {
            sendSnackBar("Error de conexión", "error");
        }

        return dataResponse;
    };

    const GetIdUsuario = () => {
        return JSON.parse(localStorage.getItem('userRetencion')).IdUsuario;
    };

    const ObtenerEdadDesdeRFC = (rfc) => {
        const rfcLimpio = rfc.trim().toUpperCase();

        const anioCorto = parseInt(rfcLimpio.substring(4, 6), 10);
        const mes = parseInt(rfcLimpio.substring(6, 8), 10) - 1;
        const dia = parseInt(rfcLimpio.substring(8, 10), 10);

        const anioActualCorto = new Date().getFullYear() % 100;
        const anioCompleto = anioCorto > anioActualCorto ? 1900 + anioCorto : 2000 + anioCorto;

        const fechaNacimiento = new Date(anioCompleto, mes, dia);
        const hoy = new Date();

        let edad = hoy.getFullYear() - fechaNacimiento.getFullYear();
        const diferenciaMeses = hoy.getMonth() - fechaNacimiento.getMonth();

        if (diferenciaMeses < 0 || (diferenciaMeses === 0 && hoy.getDate() < fechaNacimiento.getDate())) {
            edad--;
        }

        return edad;
    };

    const OnChangeRFC = (value) => {
        setRFC(value.trim().toUpperCase());

        let regex = /^[A-Z&Ñ]{3,4}[0-9]{2}(0[1-9]|1[0-2])(0[1-9]|[12][0-9]|3[01])([A-Z0-9]{3})?$/;
        if(regex.test(value.trim().toUpperCase())){
            setRFCError(false);
            setEdad(ObtenerEdadDesdeRFC(value));
        } else {
            setRFCError(true);
            setEdad("");
        }
    };

    const OnChangeEstatus = (value) => {
        setIdEstatus(value);
        setIdGruposVulnerables(GruposVulnerables[0].IdGruposVulnerables);
    };

    useEffect(() => {
        Login()
        .then(result => {
            let token = result.token;

            UsuarioActivo({ IdUsuario: GetIdUsuario() },token)
            .then(result => {
                if(result.activo === false){
                    localStorage.removeItem("userRetencion");
                    return <Redirect to='/admin'/>;
                }
            });

            ObtieneGruposVulnerables(token)
            .then(result => {
                setGruposVulnerables(result.gruposVulnerables);
            });

            ObtieneEstatusGrupo(token, { IdGrupo: 0 })
            .then(result => {
                setEstatus(result.estatus);
                let idEstatus = result.estatus[0].IdEstatus;
                setIdEstatus(idEstatus);
            });
        });
    }, []);

    return (
        <>      
            <Card style={{ marginBottom: "30px" }}>
                <Grid container spacing={3} style={{ padding: "30px" }}>
                    <Grid item xs={12} sm={12} xl={12}>
                        <Typography variant="h6">
                            Datos cliente
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} xl={4}>
                        <TextField value={NombreCliente} onChange={(event) => setNombreCliente(event.target.value)} inputProps={{ maxLength: 255 }} label="Nombre del cliente" variant="outlined" style={{ width: "100%" }} />
                    </Grid>
                    <Grid item xs={12} sm={6} xl={4}>
                        <TextField value={Producto} onChange={(event) => setProducto(event.target.value)} inputProps={{ maxLength: 255 }} label="Producto" variant="outlined" style={{ width: "100%" }} error={ProductoError} required /> 
                    </Grid>
                    <Grid item xs={12} sm={6} xl={4}>
                        <TextField value={UltimosDigitos} onChange={(event) => setUltimosDigitos(event.target.value)} inputProps={{ maxLength: 6 }} label="Últimos 6 dígitos" variant="outlined" style={{ width: "100%" }} error={UltimosDigitosError} required /> 
                    </Grid>
                    <Grid item xs={12} sm={6} xl={4}>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <FormControl style={{ width: "100%", marginTop: "-9px" }}>
                                <DemoContainer components={['DatePicker']}>
                                    <DatePicker
                                        format="yyyy/MM/dd"
                                        label="Fecha de cobro"
                                        value={FechaCobro}
                                        onChange={(date) => setFechaCobro(date)}
                                        slotProps={{ textField: { fullWidth: true } }}
                                        renderInput={(props) => <TextField {...props} />}
                                    />
                                </DemoContainer>
                            </FormControl>
                        </LocalizationProvider>
                    </Grid>
                    <Grid item xs={12} sm={6} xl={4}>
                        <TextField value={AltaRenovacion} onChange={(event) => setAltaRenovacion(event.target.value)} inputProps={{ maxLength: 100 }} label="Alta renovacion vigente" variant="outlined" style={{ width: "100%" }} /> 
                    </Grid>
                </Grid>
            </Card>
            <Card style={{ marginBottom: "30px" }}>
                <Grid container spacing={3} style={{ padding: "30px" }}>
                    <Grid item xs={12} sm={12} xl={12}>
                        <Typography variant="h6">
                            Autenticación
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} xl={4}>
                        <TextField value={Correo} onChange={(event) => setCorreo(event.target.value)} inputProps={{ maxLength: 100 }} label="Correo" type="email" variant="outlined" style={{ width: "100%" }} /> 
                    </Grid>
                    <Grid item xs={12} sm={6} xl={4}>
                        <TextField label="RFC" value={RFC} onChange={(event) => OnChangeRFC(event.target.value)} inputProps={{ maxLength: 13 }} variant="outlined" style={{ width: "100%" }} error={RFCError} required />
                    </Grid>
                    <Grid item xs={12} sm={6} xl={4}>
                        <TextField label="Edad" value={Edad} disabled={true} variant="outlined" style={{ width: "100%" }} />
                    </Grid>
                    <Grid item xs={12} sm={6} xl={4}>
                        <TextField label="Teléfono" value={Telefono} onChange={(event) => setTelefono(event.target.value)} inputProps={{ maxLength: 10 }} variant="outlined" style={{ width: "100%" }} />
                    </Grid>
                </Grid>
            </Card>
            <Card style={{ marginBottom: "30px" }}>
                <Grid container spacing={3} style={{ padding: "30px" }}>
                    <Grid item xs={12} sm={12} xl={12}>
                        <Typography variant="h6">
                            Retención
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} xl={4}>
                        <TextField value={CanalVenta} onChange={(event) => setCanalVenta(event.target.value)} inputProps={{ maxLength: 255 }} label="Canal de venta" type="email" variant="outlined" style={{ width: "100%" }} /> 
                    </Grid>
                    <Grid item xs={12} sm={6} xl={4}>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <FormControl style={{ width: "100%", marginTop: "-9px" }}>
                                <DemoContainer components={['DatePicker']}>
                                    <DatePicker
                                        format="yyyy/MM/dd"
                                        label="Fin programa cero"
                                        value={FinPrograma}
                                        onChange={(date) => setFinPrograma(date)}
                                        slotProps={{ textField: { fullWidth: true } }}
                                        renderInput={(props) => <TextField {...props} />}
                                    />
                                </DemoContainer>
                            </FormControl>
                        </LocalizationProvider>
                    </Grid>
                    <Grid item xs={12} sm={6} xl={4}>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <FormControl style={{ width: "100%", marginTop: "-9px" }}>
                                <DemoContainer components={['DatePicker']}>
                                    <DatePicker
                                        format="yyyy/MM/dd"
                                        label="Fecha informacion"
                                        value={FechaInformacion}
                                        onChange={(date) => setFechaInformacion(date)}
                                        slotProps={{ textField: { fullWidth: true } }}
                                        renderInput={(props) => <TextField {...props} />}
                                    />
                                </DemoContainer>
                            </FormControl>
                        </LocalizationProvider>
                    </Grid>
                    <Grid item xs={12} sm={6} xl={4}>
                        <TextField label="Meses restantes con P0" value={MesesRestantes} onChange={(event) => setMesesRestantes(event.target.value)} inputProps={{ maxLength: 45 }} variant="outlined" style={{ width: "100%" }} />
                    </Grid>
                    <Grid item xs={12} sm={6} xl={4}>
                        <TextField label="Monto cobrado" value={MontoCobrado} onChange={(event) => setMontoCobrado(event.target.value)} inputProps={{ maxLength: 31, type: "number" }} variant="outlined" style={{ width: "100%" }} />
                    </Grid>
                    <Grid item xs={12} sm={6} xl={4}>
                        <TextField label="Linea de credito" value={LineaCredito} onChange={(event) => setLineaCredito(event.target.value)} inputProps={{ maxLength: 31, type: "number" }} variant="outlined" style={{ width: "100%" }} />
                    </Grid>
                    <Grid item xs={12} sm={6} xl={4}>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <FormControl style={{ width: "100%", marginTop: "-9px" }}>
                                <DemoContainer components={['DatePicker']}>
                                    <DatePicker
                                        format="yyyy/MM/dd"
                                        label="Fecha corte"
                                        value={FechaCorte}
                                        onChange={(date) => setFechaCorte(date)}
                                        slotProps={{ textField: { fullWidth: true } }}
                                        renderInput={(props) => <TextField {...props} />}
                                    />
                                </DemoContainer>
                            </FormControl>
                        </LocalizationProvider>
                    </Grid>
                </Grid>
            </Card>
            <Card style={{ marginBottom: "30px" }}>
                <Grid container spacing={3} style={{ padding: "30px" }}>
                    <Grid item xs={12} sm={12} xl={12}>
                        <Typography variant="h6">
                            Estatus
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} xl={4}>
                        <TextField
                            select
                            label="Estatus*"
                            value={IdEstatus} 
                            onChange={(event) => OnChangeEstatus(event.target.value)}
                            style={{ width: "100%" }}
                        >
                            {Estatus.map((option) => (
                                <MenuItem key={option.IdEstatus} value={option.IdEstatus}>
                                    {option.Nombre}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                    <Grid item xs={12} sm={6} xl={4}>
                        <TextField
                            select
                            label="Grupos Vulnerables*"
                            value={IdGruposVulnerables} 
                            onChange={(event) => setIdGruposVulnerables(event.target.value)} 
                            style={{ width: "100%" }}
                        >
                            {GruposVulnerables.map((option) => (
                                <MenuItem key={option.IdGruposVulnerables} value={option.IdGruposVulnerables}>
                                    {option.Nombre}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                    <Grid item xs={12} sm={6} xl={4}>
                        <TextField label="Folio Cancelación" value={FolioCancelacion} disabled={true} variant="outlined" style={{ width: "100%" }} />
                    </Grid>
                    <Grid item xs={12} sm={12} xl={12}>
                        <DataGrid
                            rows={Comentarios}
                            columns={columnsComments}
                            slots={{
                                toolbar: EditToolbar,
                            }}
                            sx={{
                                '& .MuiInputBase-root':
                                {
                                    padding: '10px 30px 10px 0 !important',
                                    width: 'auto !important'
                                },
                                '& .MuiInputBase-root svg':
                                {
                                    display: 'block',
                                    width: '2em',
                                    height: '2em',
                                    top: 'calc(50% - 1em)'
                                },
                                '& .MuiSelect-select':
                                {
                                    width: '100% !important',
                                },
                            }}
                        />
                    </Grid>
                </Grid>
            </Card>
            <Card style={{ marginBottom: "30px" }}>
                <Grid container spacing={3} style={{ padding: "30px" }}>
                    <Grid item xs={12} sm={12} xl={12}>
                        <Typography variant="h6">
                            Extras
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} xl={4}>
                        <TextField label="Programa Lealtad" value={ProgramaLealtad} onChange={(event) => setProgramaLealtad(event.target.value)} inputProps={{ maxLength: 45 }} variant="outlined" style={{ width: "100%" }} /> 
                    </Grid>
                    <Grid item xs={12} sm={6} xl={4}>
                        <TextField label="Nombre Adicional" value={NombreAdicional} onChange={(event) => setNombreAdicional(event.target.value)} inputProps={{ maxLength: 255 }} variant="outlined" style={{ width: "100%" }} error={NombreAdicionalError} required />
                    </Grid>
                    <Grid item xs={12} sm={6} xl={4}>
                        <TextField label="Programa Cero" value={ProgramaCero} onChange={(event) => setProgramaCero(event.target.value)} inputProps={{ maxLength: 10 }} variant="outlined" style={{ width: "100%" }} />
                    </Grid>
                    <Grid item xs={12} sm={6} xl={4}>
                        <TextField label="Acelerador" value={Acelerador} onChange={(event) => setAcelerador(event.target.value)} inputProps={{ maxLength: 10 }} variant="outlined" style={{ width: "100%" }} />
                    </Grid>
                    <Grid item xs={12} sm={6} xl={4}>
                        <TextField label="Perfil Cliente" value={PerfilCliente} onChange={(event) => setPerfilCliente(event.target.value)} inputProps={{ maxLength: 255 }} variant="outlined" style={{ width: "100%" }} />
                    </Grid>
                </Grid>
            </Card>
            <Grid container
                direction="row-reverse"
                justifyContent="flex-start"
                alignItems="center">
                <Grid item xs={12} sm={12} xl={3}>
                    <Button
                        color="info"
                        variant="contained"
                        onClick={EnviaDatos}
                        style={{ float: "right" }}
                        size="large"
                        >
                            { "Enviar" }
                    </Button>
                </Grid>
            </Grid>
            <Dialog
                open={openDialog}
                TransitionComponent={Transition}
                keepMounted
                onClose={DialogClose}
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle>{"Registro exitoso"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                        <Typography variant="body1" gutterBottom>
                            {`Teléfono: ${Telefono}`}
                        </Typography>
                        {
                            FolioCancelacion !== '' ?
                            <Typography variant="body1" gutterBottom>
                                {'Folio de cancelación: ' + FolioCancelacion}
                            </Typography> 
                            : null
                        }
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={DialogClose}>Aceptar</Button>
                </DialogActions>
            </Dialog>
            <Dialog
                fullWidth={true}
                fullScreen={fullScreen}
                open={openDialogComment}
                onClose={() => setOpenDialogComment(false)}
                aria-labelledby="dialog"
            >
            <DialogTitle id="dialog">
                {TextoModal}
            </DialogTitle>
            <DialogContent>
                <Grid item xs={12} sm={12} xl={12} style={{ marginBottom: "10px", paddingTop: "10px" }}>
                    <TextField label="Comentario" value={Comentario} onChange={(event) => setComentario(event.target.value)} inputProps={{ maxLength: 255 }} variant="outlined" style={{ width: "100%" }} />
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button autoFocus onClick={() => setOpenDialogComment(false)}>
                Cancelar
                </Button>
                <Button onClick={AceptarModalComentario} autoFocus>
                Aceptar
                </Button>
            </DialogActions>
            </Dialog>
            <Snackbar anchorOrigin={{ vertical: "bottom", horizontal: "right" }} open={openSnackbar} onClose={SnackbarClose} autoHideDuration={6000}>
                <Alert onClose={SnackbarClose} severity={color} sx={{ width: '100%' }}>
                    {message}
                </Alert>
            </Snackbar>
            <Loader load={load} />
        </>
    );
}

export default Alta;